module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bbbd98ae6a34eac772e34a57aaa5f977.svg";